/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import * as React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql, Link } from 'gatsby'
import { PrismicProvider } from '@prismicio/react'
import { linkResolver } from '../../linkResolver'
import { useMergePrismicPreviewData } from 'gatsby-plugin-prismic-previews'
import SiteWideAlert from '../sitewide-alert'
import Header from '../header'
import Footer from '../footer'
import './layout.css'
import * as styles from './layout.module.css'
import withTranslationLock from '../withTransitionLock/withTransitionLock';
import ErrorBoundary from '../errorBoundary/errorBoundary';
// import GoogleTranslateWithErrorBoundary from '../googleTranslate/googleTranslate';
import { Helmet } from 'react-helmet'

const Layout = (props) => {
  const { title, children, location, section, parent } = props
  // console.log({props})
  const staticData = useStaticQuery(
    graphql`
      query SiteLayoutQuery {
        site {
          siteMetadata {
            title
          }
        }
        allPrismicSitewideAlert {
          nodes {
            data {
              alerts {
                sitewide_alert_color
                sitewide_alert_cta
                sitewide_alert_description
                sitewide_alert_long_description {
                  richText
                  text
                }
                sitewide_alert_learn_more_link {
                  url
                  id
                  link_type
                  tags
                  type
                  uid
                  target
                }
                sitewide_alert_learn_more_text
                sitewide_alert_modal_button_text
                sitewide_alert_modal_id
                sitewide_alert_title {
                  richText
                  text
                }
              }
            }
            id
            _previewable
          }
        }
        prismicFooter {
          _previewable
          data {
            footer_contact {
              richText
              text
            }
            footer_hours {
              richText
              text
            }
            footer_links {
              footer_link_text
              footer_link {
                target
                url
                link_type
                type
              }
            }
            footer_location {
              richText
              text
            }
            footer_social_links {
              footer_social_link_text
              footer_social_link_icon {
                url
                alt
              }
              footer_social_link {
                target
                type
                link_type
                url
              }
            }
          }
        }
      }
    `
  )

  const { data, isPreview } = useMergePrismicPreviewData(staticData)
  // console.log('->> LAYOUT  DATA? ->>', staticData)
  // console.log(location)

  return (
    <React.Fragment key={Math.random(0, 99999)}>
    			<ErrorBoundary
        fallback={
          <div style = {{ padding: '20px', textAlign: 'center', backgroundColor: '#f2f2f2' }}>
            <h2>Something went wrong.</h2>
            <button onClick = {() => window.location.reload()} style = {{ padding: '10px 20px', fontSize: '16px' }}>
              Reload Page
            </button>
          </div>
        }
        onError={(error, info) => {
              // Log the error to an external service if desired
          console.error('ErrorBoundary caught an error:', error, info);
        }}
      >
      <PrismicProvider // used to set up global configuration for <PrismicLink> elements
        // eslint-disable-next-line react/prop-types
        internalLinkComponent={(props) => <Link to={props?.href} {...props} />}
        linkResolver={linkResolver}
      >
        {staticData?.allPrismicSitewideAlert && (
          <SiteWideAlert
            id={staticData?.allPrismicSitewideAlert.nodes[0].id}
            alerts={staticData?.allPrismicSitewideAlert.nodes[0].data.alerts}
          />
        )}
        <div className={styles.topWrapper} id="layout-header">
          <Header location={location} section={section} />
        </div>
        <div data-wio-id={staticData?.id}>
          <main>{children}</main>
          {!location?.pathname.includes('/zoo-map') && (
            <Footer
              title={title}
              footer={staticData?.prismicFooter?.data}
              section={section}
              parent={parent}
              location={location}
            />
          )}
        </div>
        {/* <GoogleTranslateWithErrorBoundary language = "en" /> */}
      </PrismicProvider>
      </ErrorBoundary>
    </React.Fragment>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default withTranslationLock(Layout);
